import React from "react";
import { Form, Button } from "react-bootstrap";
import { 
	SearchForField
} from "../components/common";
import {
	DECISIONS_SEARCH_FOR_OPTION,
	BY_DATE_SEARCH_FOR_OPTION,
	RECORDATIONS_SEARCH_FOR_OPTION,
	LOCKED_TO_OPTIONS,
	LOCKED_TO_NO_RETURN,
	BY_DATE_SEARCHES,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
} from "../../../resources/constants/searches";
import {
	DATE_TO_VIEW_NAME,
	SEARCH_BUTTON_LABEL,
	SEARCH_FOR_NAME,
	DATE_FIELDS,
	RECORDATION_CATEGORY_FIELD,
	ENVCOM_TYPE_ID_FIELD
} from "../../../resources/constants/fields";
import { NETWORK_ERROR } from "../../../resources/constants/errors";
import Loading from "../../../scenes/Loading";
import {Spinner} from "../../../resources/media/Spinner";

import { 
	isCorrectDateFormat, 
	checkDateContinuity, 
	getTodaysDate 
} from "../../../resources/util/dateUtil";
import { 
	getSearchResultsByFields, 
	getDataAndTypeFromResponseAndType, 
	getSearchResultsByDate, 
	getQueryParams 
} from "../../../resources/util/search";
import { DataTypeSearch } from "../components/SearchLayouts";
import { 
	SearchResultsGrid, 
	DocketAssociatedPage, 
	ServiceListPage, 
	RecordationInformationPage 
} from "../components/SearchResults";
import { ENV_COMM_TYPES, RECORDATION_CATEGORIES } from "../../../resources/constants/dropdowns";


class SearchButton extends React.Component {
	render() {
		if (this.props.searchFor) {
			
			return (
				<React.Fragment>
					<Button
						variant="primary"
						type="submit"
						onClick={this.props.handleSubmit}
						size="lg"
						className="search-button auto-margin"
						disabled={this.props.disabled}
					>
						{SEARCH_BUTTON_LABEL}
					</Button>
					{this.props.loading ? <Spinner /> : <></>}
				</React.Fragment>
			);
		} else {
			return null;
		}
	}
}

class EnhancedSearchForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFor: props.searchFor,
			fields: { ...props.defaultFields },
			data: props.defaultData,
			loading: false,
			networkError: false,
			showSearch: true,
			disableSearch: false
		};
		this.handleSearchForChange = this.handleSearchForChange.bind(this);
		this.handleFieldsChange = this.handleFieldsChange.bind(this);
		this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
		this.handleSaveData = this.handleSaveData.bind(this);
		this.searchByField = this.searchByField.bind(this);
		this.setSearchVisible = this.setSearchVisible.bind(this);
		this.clearFieldsByName = this.clearFieldsByName.bind(this);
	}
	componentDidMount = () => {
		
		if (LOCKED_TO_OPTIONS.includes(this.props.lockedTo)) {
			this.getLockedToResults(this.props.lockedTo);
		}
	};
	scrollToResults = () => {
		if (document.getElementById(this.state.resultsElementId)) {
			document
				.getElementById(this.state.resultsElementId)
				.scrollIntoView();
		}
	};
	handleSearchForChange = e => {
		var fields = {};
		if (e.target.value === BY_DATE_SEARCH_FOR_OPTION) {
			fields.dateToView = getTodaysDate();
		} else if (e.target.value === RECORDATIONS_SEARCH_FOR_OPTION) {
			fields.recordationCategory = RECORDATION_CATEGORIES[0].value;
		} else if (e.target.value === ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION) {
			fields.enviroCommentTypeId = ENV_COMM_TYPES[0].value;
		}
		this.setState({
			[e.target.name]: e.target.value,
			fields: fields,
			data: null
		});
		this.props.handleDefaultFieldsOverride();
	};
	handleFieldsChange = e => {
		var fields = { ...this.state.fields };
		if(DATE_FIELDS.includes(e.target.name)) {
			if(isCorrectDateFormat(e.target.value) && checkDateContinuity(e.target.value)) {
				e.target.classList.remove("date-invalid");
			} else {
				e.target.classList.add("date-invalid");
			}
		}
		fields[e.target.name] = e.target.value;
		this.setState({ fields, data: null });
		this.props.handleDefaultFieldsOverride(fields);
	};
	clearFieldsByName = (fieldNames) => {
		var fields = { ...this.state.fields };
		for(var name in fieldNames) {
			fields[fieldNames[name]] = "";
		}
		this.setState({fields});
	}
	handleSaveData = responses => {
		var responseData = [];
		var validDataCount = 0;
		for (var responseObject in responses) {
			var searchForData = getDataAndTypeFromResponseAndType(responses[responseObject]);
			if(searchForData) {
				responseData.push(searchForData);
				validDataCount++;
			} else {
				responseData.push({
					searchFor: responses[responseObject][SEARCH_FOR_NAME],
					error:NETWORK_ERROR});
			}
		}
		if(validDataCount) {
			this.setState({
				data: responseData,
				networkError: false,
				loading: false,
				showSearch: false
			});
		} else{
			this.setState({
				data: null,
				networkError: true,
				loading: false,
				showSearch: true
			});
		}
	};
	handleSearchSubmit = e => {
		let doSubmit = true;
		if(document.getElementsByClassName("is-invalid").length > 0 || 
			document.getElementsByClassName("date-invalid").length > 0 || 
			(this.state.searchFor === BY_DATE_SEARCH_FOR_OPTION && 
			this.state.fields.dateToView === "")
		) {
			this.setState({
				disableSearch: true
			});
			doSubmit = false;
		}
		for(var idx in DATE_FIELDS) {
			let element = document.getElementsByName(DATE_FIELDS[idx])[0];
			if(element && !element.checkValidity()) {
				this.setState({
					disableSearch: true
				});
				doSubmit = false;
			}
		}
		if(doSubmit) {
			if(!this.state.loading) {
				e.preventDefault();
				this.searchByField(this.state);
			}
		}
	};
	searchByField = async params => {
		this.setState({
			loading: true,
			networkError: false
		});
		var responses;
		if (params.searchFor === BY_DATE_SEARCH_FOR_OPTION) {
			responses = await getSearchResultsByDate(params, BY_DATE_SEARCHES);
		} else {
			responses = await getSearchResultsByFields(params);
		}
		this.handleSaveData(responses);
	};
	getLockedToResults = lockedTo => {
		var searchParams = {
			searchFor: lockedTo,
			fields: this.state.fields
		};
		this.searchByField(searchParams);
	};
	setSearchVisible = () => {
		this.setState({ showSearch: true });
	}
	getErrors = e => {
		if (this.state.networkError)
			return (
				<div className="center invalid-feedback show">
					<p className={"shortLine"}>{NETWORK_ERROR}</p>
				</div>
			);
	};
	componentDidUpdate() {
		for(var dateField in DATE_FIELDS) {
			let element = document.getElementsByName(DATE_FIELDS[dateField])[0];
			if(element && !element.value) {
				if(DATE_FIELDS[dateField] === DATE_TO_VIEW_NAME) {
					element.classList.add("date-invalid");
				} else if(element.checkValidity()) {
					element.classList.remove("date-invalid");
				}
			}
		}
		if(!this.state.disableSearch && 
			(document.getElementsByClassName("is-invalid").length > 0 || 
			document.getElementsByClassName("date-invalid").length > 0 ||
			(this.state.searchFor === BY_DATE_SEARCH_FOR_OPTION &&
			this.state.fields.dateToView === ""))
		) {
			this.setState({disableSearch: true});
		}
		else if(this.state.disableSearch && 
			document.getElementsByClassName("is-invalid").length === 0 && 
			document.getElementsByClassName("date-invalid").length === 0 &&
			!(this.state.searchFor === BY_DATE_SEARCH_FOR_OPTION &&
			this.state.fields.dateToView === "")
		) {
			this.setState({disableSearch: false});
		}
	}
	render() {
		var autoLoadResults = LOCKED_TO_OPTIONS.includes(this.props.lockedTo);
		var hideReturnBtn = LOCKED_TO_NO_RETURN.includes(this.props.lockedTo);
		var showFullScreenLoading = autoLoadResults && this.state.loading;
		return (
			<Form id="enhanced_search" className="enhancedSearchForm">
				{this.state.showSearch ? (
					<React.Fragment>
						<SearchForField
							handleChange={this.handleSearchForChange}
							searchFor={this.state.searchFor}
							lockedTo={this.props.lockedTo}
							defaultFields={this.props.defaultFields}
						/>
						<br/>
						<DataTypeSearch
							handleChange={this.handleFieldsChange}
							clearFieldsByName={this.clearFieldsByName}
							searchFor={this.state.searchFor}
							fields={this.state.fields}
							lockedTo={this.props.lockedTo}
						/>
						<SearchButton
							disabled={this.state.disableSearch}
							searchFor={this.state.searchFor}
							handleSubmit={this.handleSearchSubmit}
							loading={this.state.loading}
						/>
						{this.getErrors()}
					</React.Fragment>
				) : null}
				{this.state.showSearch ? showFullScreenLoading ? <Loading/> : null : (
					<SearchResultsGrid
						showSearch={!this.state.showSearch}
						data={this.state.data}
						isByDateSearch={this.state.searchFor === BY_DATE_SEARCH_FOR_OPTION}
						hideReturnBtn={hideReturnBtn}
						searchFor={this.state.searchFor}
						lockedTo={this.props.lockedTo}
						fields={this.state.fields}
						handleDocketNumClickin={
							this.props.handleDocketNumClickin
						}
						handleGenerateServiceListClickIn={
							this.props.handleGenerateServiceListClickIn
						}
						handleGenerateRecordationClickIn={
							this.props.handleGenerateRecordationClickIn
						}
						handleReturnToSearch={this.setSearchVisible}
					/>
				)}
			</Form>
		);
	}
}

class EnhancedSearch extends React.Component {
	constructor(props) {
		super(props);
		var [searchFor, defaultFields] = getQueryParams(props.lockedTo, props.defaultFields);
		this.state = {
			defaultFields: defaultFields,
			defaultData: null,
			searchFor: searchFor, //props.lockedTo || DECISIONS_SEARCH_FOR_OPTION
			docketClickIn: null,
			serviceListClickIn: null,
			recordationClickIn: null
		};
		this.handleDocketNumClickin = this.handleDocketNumClickin.bind(this);
		this.handleDefaultFieldsOverride = this.handleDefaultFieldsOverride.bind(
			this
		);
		this.handleGenerateRecordationClickIn = this.handleGenerateRecordationClickIn.bind(this);
		this.handleDefaultDataOverride = this.handleDefaultDataOverride.bind(
			this
		);
		this.handleReturnToSearch = this.handleReturnToSearch.bind(this);
	}
	handleDocketNumClickin = e => {
		this.setState({ docketClickIn: e.target.value });
	};
	handleGenerateServiceListClickIn = e => {
		this.setState({ serviceListClickIn: e.target.value });
	};
	handleGenerateRecordationClickIn = e => {
		this.setState({ recordationClickIn: e.target.value });
	};
	handleDefaultFieldsOverride = fields => {
		this.setState({ defaultFields: fields });
	};
	handleDefaultDataOverride = data => {
		this.setState({ defaultData: data });
	};
	handleReturnToSearch = searchFor => {
		var defaultFields = {};
		if(searchFor === RECORDATIONS_SEARCH_FOR_OPTION) {
			if(this.state.defaultFields && this.state.defaultFields.recordationCategory) {
				defaultFields = this.state.defaultFields;
			} else {
				defaultFields[RECORDATION_CATEGORY_FIELD] = RECORDATION_CATEGORIES[0].value;
			}
		} else if(searchFor === ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION) {
			if(this.state.defaultFields && this.state.defaultFields.enviroCommentTypeId) {
				defaultFields = this.state.defaultFields;
			} else {
				defaultFields[ENVCOM_TYPE_ID_FIELD] = ENV_COMM_TYPES[0].value;
			}
		}
		this.setState({
			defaultFields: defaultFields,
			docketClickIn: null,
			serviceListClickIn: null,
			serviceListData: null,
			recordationClickIn: null,
			searchFor: searchFor || DECISIONS_SEARCH_FOR_OPTION
		});
	};
	render() {
		if (this.state.docketClickIn) {
			return (
				<DocketAssociatedPage
					docketClickIn={this.state.docketClickIn}
					handleReturnToSearch={this.handleReturnToSearch}
				/>
			);
		} else if (this.state.serviceListClickIn) {
			return (
				<ServiceListPage
					serviceListClickIn={this.state.serviceListClickIn}
					handleReturnToSearch={this.handleReturnToSearch}
				/>
			);
		} else if (this.state.recordationClickIn) {
			return (
				<RecordationInformationPage
					recordationClickIn={this.state.recordationClickIn}
					handleReturnToSearch={this.handleReturnToSearch}
					lockedTo={this.props.lockedTo}
				/>
			);
		} else {
			return (
				<EnhancedSearchForm
					searchFor={this.state.searchFor}
					lockedTo={this.props.lockedTo}
					defaultFields={this.state.defaultFields}
					defaultData={this.state.defaultData}
					handleDefaultFieldsOverride={
						this.handleDefaultFieldsOverride
					}
					handleDefaultDataOverride={this.handleDefaultDataOverride}
					handleDocketNumClickin={this.handleDocketNumClickin}
					handleGenerateServiceListClickIn={
						this.handleGenerateServiceListClickIn
					}
					handleGenerateRecordationClickIn={
						this.handleGenerateRecordationClickIn
					}
				/>
			);
		}
	}
}

export default EnhancedSearch;
